import { Injectable } from '@angular/core';
import { SettingsProvider, SettingLifetime } from '../settings';
import { WorkspaceType } from '../workspace_enums';
import { GridState } from '../../components/workspace/objects/grid';
import { UserProvider } from '../user';

@Injectable()
export class GridSettingsProvider {
    constructor(private settingsProvider: SettingsProvider, private userProvider: UserProvider) {}

    public getSettings(workspaceType: WorkspaceType): GridState {
        let color = '#eea83b';
        let visible = false;
        let rows = 10;
        let columns = 10;
        switch (workspaceType) {
            case WorkspaceType.SceneRecognition:
                color = this.settingsProvider.get('scenerecognition.workspace.grid.color');
                visible = this.settingsProvider.get('scenerecognition.workspace.grid.visible');
                rows = this.settingsProvider.get('scenerecognition.workspace.grid.rows');
                columns = this.settingsProvider.get('scenerecognition.workspace.grid.columns');
                break;
            case WorkspaceType.AnomalyRecognition:
                color = this.settingsProvider.get('anomalyrecognition.workspace.grid.color');
                visible = this.settingsProvider.get('anomalyrecognition.workspace.grid.visible');
                rows = this.settingsProvider.get('anomalyrecognition.workspace.grid.rows');
                columns = this.settingsProvider.get('anomalyrecognition.workspace.grid.columns');
                break;
            case WorkspaceType.ObjectDetection:
                if (this.userProvider.hasDetectionBrainsCapability()) {
                    color = this.settingsProvider.get('detection.workspace.grid.color');
                    visible = this.settingsProvider.get('detection.workspace.grid.visible');
                    rows = this.settingsProvider.get('detection.workspace.grid.rows');
                    columns = this.settingsProvider.get('detection.workspace.grid.columns');
                }

                break;
            default:
                throw new Error(`Invalid workspace type: ${workspaceType}`);
        }

        return {
            color,
            visible,
            rows,
            columns
        };
    }

    public async persistSettings(workspaceType: WorkspaceType, state: GridState): Promise<void> {
        switch (workspaceType) {
            case WorkspaceType.SceneRecognition:
                await this.settingsProvider.setAll(
                    {
                        'scenerecognition.workspace.grid.color': state.color,
                        'scenerecognition.workspace.grid.visible': state.visible,
                        'scenerecognition.workspace.grid.rows': state.rows,
                        'scenerecognition.workspace.grid.columns': state.columns
                    },
                    SettingLifetime.Session
                );
                break;
            case WorkspaceType.AnomalyRecognition:
                await this.settingsProvider.setAll(
                    {
                        'anomalyrecognition.workspace.grid.color': state.color,
                        'anomalyrecognition.workspace.grid.visible': state.visible,
                        'anomalyrecognition.workspace.grid.rows': state.rows,
                        'anomalyrecognition.workspace.grid.columns': state.columns
                    },
                    SettingLifetime.Session
                );
                break;
            case WorkspaceType.ObjectDetection:
                if (this.userProvider.hasDetectionBrainsCapability()) {
                    await this.settingsProvider.setAll(
                        {
                            'detection.workspace.grid.color': state.color,
                            'detection.workspace.grid.visible': state.visible,
                            'detection.workspace.grid.rows': state.rows,
                            'detection.workspace.grid.columns': state.columns
                        },
                        SettingLifetime.Session
                    );
                }

                break;
            default:
                return;
        }
    }
}



// WEBPACK FOOTER //
// ./src/providers/workspace/grid-settings.ts